import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const PageHeader = ({ pageTitle, children }) => {
  const { id: accountId, name: accountName } = useSelector(
    state => state.account.current
  )

  return (
    <div className="tit_dsp">
      <h3 className="tit_subject">{pageTitle}</h3>
      <strong className="sub_title">{accountName}</strong>
      <span className="sub_code">{accountId}</span>
      {children}
    </div>
  )
}

PageHeader.propTypes = {
  pageTitle: PropTypes.string,
  children: PropTypes.node,
}

export default PageHeader
